import { useCallback, useContext } from 'react';

import { TokenContext } from '@/Contexts/TokenContext';
import { ApplicationAnswerProps } from '@/models/Application';
import { baseUrl } from '@/utils/constants';

import { useCustomFetch } from './useCustomFetch';

export default function useQuestionResponse() {
  const { customFetch } = useCustomFetch();

  const { authResult } = useContext(TokenContext);

  const getQuestionAnswer = useCallback(
    async (
      questionId: number | string,
      appId: number | string
    ): Promise<ApplicationAnswerProps | null> => {
      const url = `${baseUrl}QuestionResponse?applicationId=${appId}&questionId=${questionId}`;

      const response = await customFetch<ApplicationAnswerProps>(url, {
        method: 'GET',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Authorization: `Bearer ${authResult.accessToken}`,
        },
      });

      return response;
    },
    [authResult, customFetch]
  );

  return {
    getQuestionAnswer,
  };
}
